<div tooltip="{{toolTipText}}"><span class="fa-stack tooltip-info-icon u-pointer">
    <i class="fa fa-circle fa-stack-2x"></i>
    <i class="fa fa-info fa-stack-1x" [ngClass]=" inverted ? 'info-icon-inverse' : 'fa-inverse'"></i>
  </span>
</div>